export const Header = () => {
  const year = new Date().getFullYear()
  return (
    <header className="mx-auto w-full max-w-2xl px-6 sm:px-8 pt-10">
      <div className="flex items-center justify-between text-xs text-ink-400 font-mono tracking-wider">
        <span>NISHINO0719</span>
        <span aria-hidden="true" className="tabular-nums">{year}</span>
      </div>
    </header>
  )
}
